import {t} from "shared/core";

export function toSentence(arr) {
  const length = arr.length;

  const wordsConnector = t('components.to_sentence.WORDS_CONNECTOR');
  const twoWordsConnector = t('components.to_sentence.TWO_WORDS_CONNECTOR');
  const lastWordConnector = t('components.to_sentence.LAST_WORD_CONNECTOR');

  switch (length) {
    case 0:
      return '';
    case 1:
      return arr[0];
    case 2:
      return `${arr[0]}${twoWordsConnector}${arr[1]}`
    default:
      return `${arr.slice(0, -1).join(wordsConnector)}${lastWordConnector}${arr[length - 1]}`
  }
}
